module.exports = __webpack_public_path__ + "static/img/clients-icon-7.b9fc575.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/clients-icon-7.png
// module id = 83
// module chunks = 0